export class CalendarFormat {
    public static dateFormat: string[] = [
        'D M YYYY', 'D MM YYYY', 'DD M YYYY', 'DD MM YYYY',
        'D.M.YYYY', 'D.MM.YYYY', 'DD.M.YYYY', 'DD.MM.YYYY',
        'D/M/YYYY', 'D/MM/YYYY', 'DD/M/YYYY', 'DD/MM/YYYY',
        'D-M-YYYY', 'D-MM-YYYY', 'DD-M-YYYY', 'DD-MM-YYYY'];
    
    public static monthFormat: string[] = [
    'MM YYYY', 'M YYYY',
    'MM.YYYY', 'M.YYYY',
    'MM/YYYY', 'M/YYYY',
    'MM-YYYY', 'M-YYYY'
    ];
    
}